runOnLoad "SuppressedAddressImports", ["show"], ->

  $("#main-content").autoReload(window.location.href)

runOnLoad "SuppressedAddressImports", ->

  fileSource = $("#suppressed_address_import_file_source")

  if fileSource.length > 0

    adjustForFileSource = ->
      if fileSource.val() == "upload"
        $("#suppressed_address_import_file_local_path").closest(".control-group").hide().find("select").attr(enabled: false)
        $("#suppressed_address_import_file").closest(".control-group").show().find("select").attr(enabled: true)
      else
        $("#suppressed_address_import_file_local_path").closest(".control-group").show().find("select").attr(enabled: true)
        $("#suppressed_address_import_file").closest(".control-group").hide().find("select").attr(enabled: false)

    fileSource.change adjustForFileSource
    adjustForFileSource()
